export default "__VITE_ASSET__BERo58wO__"